<template>
  <v-app>
        <v-app-bar
            app
            color="primary"
            dark
        >
          <v-row>
            <v-col>
              <h1 align="center">CITY-STROY</h1>
            </v-col>
          </v-row>
        </v-app-bar>
    <v-main>
      <template>
        <v-bottom-navigation
            :value="value"
            color="teal"
            grow
        >
          <v-btn to="/salary2/about">
            <span>Квартальный отчет</span>

            <v-icon>mdi-briefcase-check</v-icon>
          </v-btn>

          <v-btn to="/salary2/moveMoney">
            <span>Движение денег</span>

            <v-icon>mdi-cash-multiple</v-icon>
          </v-btn>

          <v-btn to="/salary2/">
            <span>Отчет по объектам</span>

            <v-icon>mdi-briefcase-account</v-icon>
          </v-btn>

          <v-btn to="/salary2/selfEmployed">
            <span>Отчет по самозанятым</span>

            <v-icon>mdi-account-box-multiple</v-icon>
          </v-btn>

          <v-btn to="/salary2/report_tech">
            <span>Отчет по технике</span>

            <v-icon>mdi-movie-check</v-icon>
          </v-btn>

          <v-btn to="/salary2/import">
            <span>Загрузка данных из 1с</span>

            <v-icon>mdi-briefcase-download</v-icon>
          </v-btn>
          <v-btn to="/salary2/planTech">
            <span>План техника/материалы</span>

            <v-icon>mdi-align-horizontal-left</v-icon>
          </v-btn>
          <v-btn to="/salary2/payInvoice">
            <span>Платежный документ</span>

            <v-icon>mdi-briefcase-download</v-icon>
          </v-btn>
        </v-bottom-navigation>
      </template>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data(){
    return{
     value: 1
    }
  },
};
</script>
